export const createSearchGifsRequest = (query, page = 1, per_page = 25) => {
  return {
    url: "/gifs/search",
    method: "GET",
    params: { query, page, per_page },
    disableLoading: true,
  };
};
